<template>
  <div class="i-workplace-traits">
    <iBaseHeader
      highlight-text="Common Workplace Traits"
      :version="2"
      font-size-highlighted-text="16px"
      text=""
      align="start"
    />
    <iBaseHeader
      highlight-text=""
      text="Understanding key characteristics that influence your work style"
      align="start"
    />

    <iKeywordDetailsSummary
      v-if="!!workplaceTraitsSummary && !!workplaceTraitsItems"
      :data="workplaceTraitsItems"
      :summary="workplaceTraitsSummary"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useReportStore } from "@/stores/report"

import iBaseHeader from "@/components/base/BaseHeader.vue"
import iKeywordDetailsSummary from "@/components/report/KeywordDetailsSummary.vue"

// STORES AND COMPOSABLES
const reportStore = useReportStore()

// COMPUTED
const workplaceTraitsSummary = computed(() => reportStore.getWorkplaceTraitsSummary)
const workplaceTraitsItems = computed(() => reportStore.getWorkplaceTraitsItems)
</script>
